import React from 'react'

import { Button, Icon, Payment } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

import SubscriptionEntryPoints from 'Pods/Shared/Constants/subscriptionEntryPoints'
import { setSubscriptionEntry } from 'Pods/Shared/Utils/subscriptionEntry'

const NAVIGATION_SAFETY_TIMEOUT_MS = 1500

function SubscribeButton({ paymentFormPath, label = 'Subscribe and save', onClick: handleClick }) {
  const buildHref = () => {
    try {
      const url = new URL(paymentFormPath, window.location.origin)
      url.searchParams.set('return_url', window.location.href)
      return url.toString()
    } catch {
      return paymentFormPath
    }
  }

  const openInNewTab = () => {
    setSubscriptionEntry(SubscriptionEntryPoints.ITEM_PAGE_DIRECT)
    window.open(buildHref(), '_blank', 'noopener')
  }

  const handleAuxClick = (event) => {
    if (event.button === 1) openInNewTab()
  }

  const handleNavigate = (event) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey) {
      openInNewTab()
      return
    }

    setSubscriptionEntry(SubscriptionEntryPoints.ITEM_PAGE_DIRECT)

    const href = buildHref()

    let navigated = false
    const navigate = () => {
      if (navigated) return
      navigated = true
      window.location.href = href
    }

    if (typeof handleClick === 'function') {
      handleClick(navigate)
      setTimeout(navigate, NAVIGATION_SAFETY_TIMEOUT_MS)
    } else {
      navigate()
    }
  }

  return (
    <Button
      type="primary-warning"
      size="large"
      customClass="pricing-area__actions-button pricing-area__subscribe-button"
      trailIcon={<Icon svgComponent={Payment} />}
      onClick={handleNavigate}
      onAuxClick={handleAuxClick}
      aria-label={label}
      data-subscription-entry={SubscriptionEntryPoints.ITEM_PAGE_DIRECT}
    >
      {label}
    </Button>
  )
}

SubscribeButton.propTypes = {
  paymentFormPath: string.isRequired,
  label: string,
  onClick: func,
}

export default SubscribeButton
